import { VacationStateTrip } from "./VacationStateTrip";

export class VacationStateLine {
  constructor() {
    this.VacationBlkHrs = "00:00";
    this.VacationDropBlkHrs = "00:00";
    this.VacationTafb = "00:00";
    this.VacationDropTafb = "00:00";
  }

  VacationTfp: number;

  VacationTfpInLine: number;

  VacationDropTfp: number;

  VacationBlkHrs: string;

  VacationDropBlkHrs: string;

  VacationTafb: string;

  VacationDropTafb: string;

  VacationDaysOff: number;

  VacationDropDaysOff: number;

  VacationLegs: number;

  VacationDropLegs: number;

  VacationFront: number;

  VacationBack: number;

  FlyPay: number;

  FlyPayInLine: number;

  VacationBacknextBp: number;

  VacationFrontNextBp: number;

  VacationTrips: VacationStateTrip[] = [];
}
